import { implementCustomExpressions } from '../__generated/implementation.js';
import { createEuroCylinderHolePolygon } from '../polygons/euro-cylinder-hole.js';
const sizeTolerance = {
    x: 1,
    y: 1
};
export const euroCylinderHoleExpressions = implementCustomExpressions({
    EuroCylinderHole: {
        $sizeX: (self)=>self.bottomWidth,
        $sizeY: (self)=>self.height,
        $innerSize: (self)=>self.topWidth,
        $sizeTolerance: ()=>sizeTolerance,
        $polygons: (self)=>[
                createEuroCylinderHolePolygon(self)
            ]
    }
});

//# sourceMappingURL=euro-cylinder.js.map